export const InfoIcon = ({
  strokeColor = "var(--color-stroke-active)",
  _className,
  ...props
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      className={_className}
      stroke={strokeColor}
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 12.833c1.611 0 3.07-.653 4.125-1.709A5.815 5.815 0 0 0 12.834 7c0-1.61-.653-3.069-1.709-4.124A5.815 5.815 0 0 0 7 1.166c-1.61 0-3.069.653-4.124 1.709a5.815 5.815 0 0 0-1.709 4.124c0 1.611.653 3.07 1.709 4.125A5.815 5.815 0 0 0 7 12.833Z"
    />
    <path
      className={_className}
      fill={strokeColor}
      fillRule="evenodd"
      d="M7 4.726a.73.73 0 1 0 0-1.458.73.73 0 0 0 0 1.458Z"
      clipRule="evenodd"
    />
    <path
      className={_className}
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 5.834v4.667"
    />
  </svg>
);
